import script from "./VModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VModal.vue?vue&type=script&setup=true&lang=js"

import "./VModal.vue?vue&type=style&index=0&id=44042593&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44042593"]])

export default __exports__